import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import LabelText from '../LabelText';
import CountryCode from './CountryCode';

const Mobile = (props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const {form_component} = props;

	const fv = useSelector(state => state.fv);

	const pageData = useSelector(state => state.pageData);
	const controller = pageData.controller;

	const contactFields = useSelector(state => state.contactFields);
	const {mobile} = contactFields;

	const registerField = () => {
		// For Shopcarts controller, only use global validator
		// For other controllers, use Redux store validator
		const validator = controller === 'Shopcarts' ? window.globalFormValidator : fv;
		
		if (validator && form_component.required) {
			const fieldName = controller === 'Shopcarts' ? 'buyer_mobile' : 'mobile';
			
			try {
				// Check if field already exists and remove it first
				if (validator.elements && validator.elements[fieldName]) {
					validator.removeField(fieldName);
				}
				
				validator.addField(fieldName, {
					validators: {
						notEmpty: {
							message: t('此欄為必須填寫')
						},
						regexp: {
							regexp: /(\d)+/i,
							message: t('手機格式錯誤')
						}
					},
					// Explicitly specify the element selector
					selector: `input[name="${fieldName}"]`
				});
			} catch (error) {
				console.error('Error registering field:', fieldName, error);
			}
		}
	};

	useEffect(() => { // to be updated after render
		registerField();
	}, [fv, controller, form_component.required, t]);

	// Listen for FormValidation reinitialization
	useEffect(() => {
		const handleReinitialization = (event) => {
			registerField();
		};

		document.addEventListener('formValidationReinitialized', handleReinitialization);
		
		return () => {
			document.removeEventListener('formValidationReinitialized', handleReinitialization);
		};
	}, [fv, controller, form_component.required, t]);

	const onChange = (e) => {
		const value = e.target.value;

		const payload = {
			field: 'mobile',
			value: value
		}

		dispatch({type: 'SET_CONTACT_FIELD', payload: payload});
		
		// Force update DOM value for FormValidation
		if (controller === 'Shopcarts') {
			const fieldName = 'buyer_mobile';
			const domElement = document.querySelector(`input[name="${fieldName}"]`);
			if (domElement) {
				domElement.setAttribute('value', value);
				domElement.value = value;
			}
		}
	}

	return (
		<div className={`flex-grow-1 form-group text ${form_component.required ? 'required' : ''}`}>
			<LabelText
				form_component={form_component}
			/>
			<div className="input-group form-group">
				<CountryCode
					form_component={form_component}
				/>
				<input
					type="text"
					name={controller === 'Shopcarts' ? 'buyer_mobile' : 'mobile'}
					inputMode="numeric"
					placeholder={form_component.default_text_type === 'placeholder' ? form_component.default_text : ''}
					id={controller === 'Shopcarts' ? 'buyer-mobile' : 'mobile'}
					className="form-control"
					value={mobile || ''}
					onChange={onChange}
				/>	
			</div>
		</div>
	);
}

export default Mobile;